import { Checkbox } from '@/components/shadcn/ui/checkbox';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

interface FormCheckboxProps extends Omit<
  React.ComponentProps<typeof Checkbox>,
  'checked' | 'onCheckedChange'
> {
  text?: string;
  showErrorMessage?: boolean;
}

export function FormCheckbox({
  text,
  showErrorMessage = true,
  ...props
}: FormCheckboxProps) {
  const field = useFieldContext<boolean>();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Checkbox
          id={field.name}
          checked={field.state.value ?? false}
          onCheckedChange={(checked) => field.handleChange(checked === true)}
          {...props}
        />
        {text && (
          <label htmlFor={field.name} className="text-sm cursor-pointer">
            {text}
          </label>
        )}
      </div>
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}
